import { useMutation } from '@tanstack/react-query'

import { generateBriefFromContent } from '../api'

const useGenerateBriefFromContentMutation = () => {
  return useMutation({ mutationFn: generateBriefFromContent })
}

export default useGenerateBriefFromContentMutation
